import { isMatch } from 'lodash-es';

export function isObjectMatch(obj: Record<string, unknown>, source: Record<string, unknown>) {
  return isMatch(obj, source);
}
